<div class="custom-search-bar-container">
    <div class="content">
        <div *ngIf="customSearchBarConfig?.searchByOptions?.length" class="drop-down">
            <button 
                mat-button 
                [matMenuTriggerFor]="searchByMenu" 
                [disabled]="disabled 
                    || (customSearchBarConfig.searchByOptions && customSearchBarConfig.searchByOptions.length <= 1)"
            >
                <div class="mat-body-2 text-truncate m-0">{{customSearchBarConfig.selectedSearchByOptions?.name}}</div>
                <mat-icon 
                    class="material-icons-outlined" 
                    [class.text-hint]="!disabled 
                        && (customSearchBarConfig.searchByOptions && customSearchBarConfig.searchByOptions.length > 1)"
                    >expand_more</mat-icon>
            </button>
            <mat-menu class="custom-search-menu-container" #searchByMenu="matMenu">
                <ng-container *ngFor="let srchOption of customSearchBarConfig.searchByOptions; let i=index">
                    <button 
                        mat-menu-item 
                        [ngClass]="{'mat-active': srchOption.name == customSearchBarConfig.selectedSearchByOptions?.name}" 
                        (click)="selectSearchByOption(i)"
                        (keydown)="preventEventAction($event)"
                        >{{srchOption.name}}</button>
                </ng-container>
            </mat-menu>
        </div>
    
        <div class="custom-search-bar">
            <input 
                #searchInput
                #trigger="matAutocompleteTrigger"
                type="text" 
                [placeholder]="customSearchBarConfig.selectedSearchByOptions?.placeholder || customSearchBarConfig.input.placeholder" 
                [(ngModel)]="customSearchBarConfig.input.value" 
                (ngModelChange)="onModelChange()"
                (keyup.enter)="emitSearchAction(true)" 
                [matAutocomplete]="auto" 
                [disabled]="disabled"
                [class.text-disabled]="disabled"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="null">
                <mat-option *ngFor="let option of searchAutoComplete" [value]="option">
                    {{ option }}
                </mat-option>
            </mat-autocomplete>

            <button *ngIf="customSearchBarConfig.searchBtn" mat-icon-button (click)="emitSearchAction(false)" [disabled]="disabled" [matTooltip]="'Search'">
                <mat-icon [class]="customSearchBarConfig.searchBtn.iconClass" [class.text-hint]="!disabled">{{customSearchBarConfig.searchBtn.icon}}</mat-icon>
            </button>
        </div>
    </div>

    <ng-container *ngIf="customSearchBarConfig.resetBtn">
        <div class="actions">        
            <button mat-icon-button (click)="resetAction()" [disabled]="disabled" [matTooltip]="'Reset'">
                <mat-icon [class]="customSearchBarConfig.resetBtn.iconClass" [class.text-hint]="!disabled">{{customSearchBarConfig.resetBtn.icon}}</mat-icon>
            </button>
        </div>
    </ng-container>
</div>